module.exports = __webpack_public_path__ + "static/assets/3091f3dddc7ebb85ed63b260000a30a9.svg";